import styled from "styled-components";
import { CopyOutlined, CheckOutlined } from "../../icons";
import { useClipboard } from "../../hooks";
import Tooltip from "../tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
const Operation = styled.span.withConfig({
  displayName: "copy-operation__Operation",
  componentId: "sc-utxcre-0"
})(["margin-left:", "px;cursor:pointer;"], props => props.theme.space.sm);
const CopyIcon = styled(CopyOutlined).withConfig({
  displayName: "copy-operation__CopyIcon",
  componentId: "sc-utxcre-1"
})(["color:", ";transition:all 0.3s;&:hover,&:focus{color:", ";}&:active{color:", ";}"], props => props.theme.colors.primary.base, props => props.theme.colors.primary.hover, props => props.theme.colors.primary.active);
const SuccessIcon = styled(CheckOutlined).withConfig({
  displayName: "copy-operation__SuccessIcon",
  componentId: "sc-utxcre-2"
})(["&,&:hover,&:focus,&:active{color:", ";}"], props => props.theme.colors.positive.base);
function CopyOperation(_ref) {
  let {
    value,
    onCopy
  } = _ref;
  const {
    copy,
    hasCopied
  } = useClipboard(value ?? "");
  const handleCopy = () => {
    copy();
    onCopy?.();
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: hasCopied ? "Copied" : "Copy",
    children: /*#__PURE__*/_jsx(Operation, {
      children: hasCopied ? /*#__PURE__*/_jsx(SuccessIcon, {}) : /*#__PURE__*/_jsx(CopyIcon, {
        onClick: handleCopy
      })
    })
  }, "copy");
}
export default CopyOperation;